var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "yxtbiz-ote-ai-ques",
      class: {
        "yxtbiz-ote-ai-ques--error":
          _vm.quesEdited.error && _vm.quesBody.showError,
        "yxtbiz-ote-ai-ques--batch": _vm.batching,
      },
    },
    [
      _vm.editing
        ? _c("ques-detail", {
            attrs: {
              quesBody: _vm.quesEditing,
              libId: _vm.libId,
              create: _vm.create,
              libName: _vm.libName,
              examId: _vm.examId,
            },
            on: {
              "update:quesBody": function ($event) {
                _vm.quesEditing = $event
              },
              "update:ques-body": function ($event) {
                _vm.quesEditing = $event
              },
              save: _vm.saveQues,
              cancel: _vm.editCancel,
            },
          })
        : [
            _c(
              "div",
              {
                staticClass: "hand",
                on: {
                  click: function ($event) {
                    return _vm.editQues()
                  },
                },
              },
              [
                _c("div", { staticClass: "flex" }, [
                  _c("div", { staticClass: "lh22" }, [
                    _vm.index
                      ? _c(
                          "span",
                          { staticClass: "color-gray-10 yxt-weight-5" },
                          [_vm._v(_vm._s(_vm.index) + ".\n          ")]
                        )
                      : _vm._e(),
                    _vm.quesEdited.error === 1
                      ? _c(
                          "span",
                          { staticClass: "yxtbiz-ote-ai-ques__error-info" },
                          [
                            _vm._v(
                              "\n            【" +
                                _vm._s(_vm.quesEdited.errorMsg) +
                                "】\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c("span", {
                      staticClass: "color-gray-10 yxt-weight-5",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.cleanStyle(_vm.quesEdited.content)
                        ),
                      },
                    }),
                  ]),
                  _c("span", { staticClass: "yxtbiz-ote-ai-ques__qt" }, [
                    _vm._v(
                      _vm._s(_vm.$t(_vm.QUES_TYPE_NAMES[_vm.quesEdited.type]))
                    ),
                  ]),
                ]),
                _c(
                  "yxt-row",
                  { staticClass: "mv4" },
                  [
                    _vm.quesEdited.type === 0
                      ? _c(
                          "yxt-radio-group",
                          {
                            staticClass: "yxtbiz-question-preview__radio-group",
                            attrs: { direction: "row", disabled: true },
                            model: {
                              value: _vm.singleAnswer,
                              callback: function ($$v) {
                                _vm.singleAnswer = $$v
                              },
                              expression: "singleAnswer",
                            },
                          },
                          _vm._l(
                            _vm.quesEdited.questionItems,
                            function (item, index) {
                              return _c(
                                "yxt-radio",
                                {
                                  key: item.id,
                                  staticClass: "yxtbiz-question-preview__radio",
                                  attrs: { value: item.answer, label: index },
                                },
                                [
                                  _c("div", { staticClass: "flex" }, [
                                    _c(
                                      "span",
                                      { staticClass: "yxtbiz-flex-shrink-0" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.convertASCIIForNum(index)
                                          ) + "."
                                        ),
                                      ]
                                    ),
                                    _c("span", {
                                      staticClass: "ml4",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.cleanStyle(item.itemContent, true)
                                        ),
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            }
                          ),
                          1
                        )
                      : _vm._e(),
                    _vm.quesEdited.type === 1
                      ? _c(
                          "yxt-checkbox-group",
                          {
                            staticClass:
                              "yxtbiz-question-preview__checkbox-group",
                            attrs: { direction: "row", disabled: true },
                            model: {
                              value: _vm.multiAnswer,
                              callback: function ($$v) {
                                _vm.multiAnswer = $$v
                              },
                              expression: "multiAnswer",
                            },
                          },
                          _vm._l(
                            _vm.quesEdited.questionItems,
                            function (item, index) {
                              return _c(
                                "yxt-checkbox",
                                {
                                  key: item.id,
                                  staticClass:
                                    "yxtbiz-question-preview__checkbox",
                                  attrs: { label: index },
                                },
                                [
                                  _c("div", { staticClass: "flex" }, [
                                    _c(
                                      "span",
                                      { staticClass: "yxtbiz-flex-shrink-0" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.convertASCIIForNum(index)
                                          ) + "."
                                        ),
                                      ]
                                    ),
                                    _c("span", {
                                      staticClass: "ml4",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.cleanStyle(item.itemContent, true)
                                        ),
                                      },
                                    }),
                                  ]),
                                ]
                              )
                            }
                          ),
                          1
                        )
                      : _vm._e(),
                    _vm.quesEdited.type === 2
                      ? _c(
                          "yxt-radio-group",
                          {
                            staticClass: "yxtbiz-question-preview__radio-group",
                            attrs: {
                              direction: "row",
                              disabled: true,
                              value: _vm.quesEdited.judgeAnswer,
                            },
                          },
                          [
                            _c(
                              "yxt-radio",
                              {
                                staticClass: "yxtbiz-question-preview__radio",
                                attrs: { label: 1 },
                              },
                              [
                                _vm._v(
                                  "\n            A.\n            " +
                                    _vm._s(
                                      _vm.quesEdited.judgeCorrectOptionContent
                                        ? _vm.quesEdited
                                            .judgeCorrectOptionContent
                                        : _vm.$t("pc_biz_ote_lbl_wright")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _c(
                              "yxt-radio",
                              {
                                staticClass: "yxtbiz-question-preview__radio",
                                attrs: { label: 0 },
                              },
                              [
                                _vm._v(
                                  "\n            B.\n            " +
                                    _vm._s(
                                      _vm.quesEdited.judgeWrongOptionContent
                                        ? _vm.quesEdited.judgeWrongOptionContent
                                        : _vm.$t("pc_biz_ote_lbl_wrong")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                [
                  _vm.quesEdited.keywords && _vm.quesEdited.keywords.length > 0
                    ? _c("div", { staticClass: "color-gray-9 mb8" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("pc_biz_ote_keyword")) + "："),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.quesEdited.keywords
                                .map(function (k) {
                                  return k.name + "(" + k.rate + "%)"
                                })
                                .join(";")
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "color-gray-9 flex" }, [
                    _c("span", { staticClass: "flex-shrink-0" }, [
                      _vm._v(
                        _vm._s(_vm.$t("pc_biz_ote_lbl_itemanswer")) + "："
                      ),
                    ]),
                    _vm.quesEdited.error === 2
                      ? _c(
                          "span",
                          { staticClass: "yxtbiz-ote-ai-ques__error-info" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.quesEdited.errorMsg) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm.quesEdited.type === 0
                      ? _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.convertASCIIForNum(_vm.singleAnswer))
                          ),
                        ])
                      : _vm.quesEdited.type === 1
                      ? _c(
                          "span",
                          _vm._l(_vm.multiAnswer, function (item, index) {
                            return _c("span", { key: item }, [
                              _vm._v(
                                _vm._s(index > 0 ? "、" : "") +
                                  _vm._s(_vm.convertASCIIForNum(item))
                              ),
                            ])
                          }),
                          0
                        )
                      : _vm.quesEdited.type === 2
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.quesEdited.judgeAnswer === 0 ? "B" : "A")
                          ),
                        ])
                      : _vm.quesEdited.type === 3
                      ? _c(
                          "span",
                          [
                            _vm.quesEdited.questionItems &&
                            _vm.quesEdited.questionItems.length
                              ? _vm._l(
                                  _vm.quesEdited.questionItems,
                                  function (item, index) {
                                    return _c("div", { key: index }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.quesEdited.questionItems
                                              .length > 1
                                              ? index + 1 + ". "
                                              : ""
                                          ) +
                                          _vm._s(item.itemContent)
                                      ),
                                      item.alternativeContents &&
                                      item.alternativeContents.length > 0
                                        ? _c("span", [
                                            _vm._v(
                                              ";" +
                                                _vm._s(
                                                  item.alternativeContents.join(
                                                    ";"
                                                  )
                                                )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  }
                                )
                              : _c("span", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("pc_biz_ote_lbl_none"))
                                    ),
                                  ]),
                                ]),
                          ],
                          2
                        )
                      : _vm.quesEdited.type === 4
                      ? _c("span", [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.cleanStyle(
                                  _vm.quesEdited.answerContent,
                                  true
                                ) || _vm.$t("pc_biz_ote_lbl_none")
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "color-gray-9 mt8" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_queslevel")) + "："),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.getLevelType(_vm.quesEdited.levelType))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "color-gray-9 mt8" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("pc_biz_ote_lbl_quesanalyze")) + "："
                      ),
                    ]),
                    _c("span", [
                      _vm.quesEdited.explainText
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.cleanStyle(_vm.quesEdited.explainText)
                              ),
                            },
                          })
                        : _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("pc_biz_ote_lbl_noquesanalysis"))
                            ),
                          ]),
                    ]),
                  ]),
                ],
                !_vm.batching
                  ? _c(
                      "div",
                      {
                        staticClass: "yxtbiz-ote-ai-ques__operations",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "yxtbiz-ote-ai-icon hand",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.editQues()
                              },
                            },
                          },
                          [
                            _c("yxt-svg", {
                              attrs: {
                                width: "16px",
                                height: "16px",
                                "icon-class": "edit",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "yxtbiz-ote-ai-icon ml8 hand",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.deleteQues()
                              },
                            },
                          },
                          [
                            _c("yxt-svg", {
                              attrs: {
                                width: "16px",
                                height: "16px",
                                "icon-class": "delete",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
          ],
      _vm.batching
        ? _c(
            "div",
            { staticClass: "yxtbiz-ote-ai-ques__batch-check" },
            [
              _c("yxt-checkbox", {
                on: { change: _vm.changeChecked },
                model: {
                  value: _vm.quesBody.checked,
                  callback: function ($$v) {
                    _vm.$set(_vm.quesBody, "checked", $$v)
                  },
                  expression: "quesBody.checked",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }